export const URL =
  process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_URL : 'http://localhost:5000';
export const DEFAULT_MESSAGE_TIMEOUT = 3000;
export const NASAK = process.env.REACT_APP_NASAK;
//NASA API URL collection
export const NASA_CME_URL = process.env.REACT_APP_NASA_CME_URL;
export const NASA_FLR_URL = process.env.REACT_APP_NASA_FLR_URL;
export const NASA_GST_URL = process.env.REACT_APP_NASA_GST_URL;
